import { useEffect, useState } from 'react'
import { useParams, useNavigate, Link } from 'react-router-dom'
import base64url from 'base64url'
import dayjs from 'dayjs'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import { useForm } from 'react-hook-form'

import { useTimerStore, useSettingsStore } from 'stores'

import {
  Main,
  Heading,
  Button,
  TextField,
} from 'components'

import {
  Timer,
  Name,
  Info,
  Buttons,
} from './importStyle'

dayjs.extend(localizedFormat)

const repeats = {
  'day': 'daily',
  'week': 'weekly',
  'month': 'monthly',
  'year': 'yearly',
}

const Import = () => {
  const dateFormat = useSettingsStore(state => state.dateFormat)
  const addTimer = useTimerStore(state => state.addTimer)
  const { data } = useParams()
  const navigate = useNavigate()
  const [parsed, setParsed] = useState()

  const {
    register,
    handleSubmit,
    setError,
    formState: { isDirty, errors },
  } = useForm()

  const onSubmit = ({ file }) => {
    const reader = new FileReader()
    reader.addEventListener('load', e => {
      try {
        const timers = JSON.parse(e.target.result)
        // Simple validation
        if (!Array.isArray(timers) || !timers.every(t => t.hasOwnProperty('name') && t.hasOwnProperty('date'))) {
          return setError('file', {
            type: 'manual',
            message: `File contents invalid, unable to import`
          })
        }
        timers.forEach(timer => addTimer(timer))
        window.alert('Import success!')
        navigate('/')
      } catch (err) {
        setError('file', {
          type: 'manual',
          message: `Invalid file, couldn't process data`
        })
        console.log(err)
      }
    })
    reader.readAsText(file[0])
  }

  useEffect(() => {
    if (data) {
      try {
        setParsed(JSON.parse(base64url.decode(data)))
      } catch (e) {
        console.error(e)
      }
    }
  }, [data])
  
  return (
    <Main center>
      <Heading>Import</Heading>

      {data ? (
        parsed ? (
          <>
            <p>Do you wish to import the following countdown?</p>

            <Timer data-color={parsed?.color}>
              <Name>{parsed?.name}</Name>
              <Info>Countdown to: {dayjs(parsed?.date).format(dateFormat)}</Info>
              {parsed?.isRepeating && <Info>Repeats <strong>{repeats[parsed?.repeatFrequency]}</strong></Info>}
            </Timer>

            <Buttons>
              <Button
                as={Link}
                secondary
                to="/"
              >Cancel</Button>
              <Button
                onClick={() => {
                  const id = addTimer(parsed)
                  navigate(`/timer/${id}`)
                }}
              >Import</Button>
            </Buttons>
          </>
        ) : (
          <>
            <p>The countdown you are trying to import is invalid.</p>
            <p>Check that you entered the correct URL.</p>
          </>
        )
      ) : (
        <form onSubmit={handleSubmit(onSubmit)}>
          <p>If you have a backup of your countdowns as a JSON file, you can import them here.</p>

          <TextField
            {...register('file')}
            label="Upload a backup"
            type="file"
            error={errors.file?.message}
          />

          <Buttons>
            <Button
              secondary
              as={Link}
              to="/settings"
            >Cancel</Button>
            <Button
              type="submit"
              disabled={!isDirty}
            >Import</Button>
          </Buttons>
        </form>
      )}
    </Main>
  )
}

export default Import